import React from 'react';

const Indicator = ({ title, value }) => {
  return (
    <div className="draught-dashboard__indicator">
      <div className="draught-dashboard__indicator-title">
        {title}
      </div>
      <div className="draught-dashboard__indicator-value">
        {value}
      </div>
    </div>
  );
};

export default Indicator;
